export var ACTION;
(function (ACTION) {
    ACTION["PHONE_CALL"] = "PHONE_CALL";
    ACTION["WHATSAPP_TEXT"] = "WHATSAPP_TEXT";
    ACTION["CLOSE_POP_UP"] = "CLOSE_POP_UP";
})(ACTION || (ACTION = {}));
